<template>
  <div>
    <MasterLayout>
      <div class="fuel_consumption_row">
        <div class="card_container" style="flex: 0 0 30%">
          <div class="row align-items-center fuel_consumption_buttons_row">
            <div class="col-md-12 fuel_consumption_btn_div">
              <div class="text-center voucher_type mt-2">
                <h3>{{ totalTran }}</h3>
                <p>{{ $t("text.pumps.transactions") }}</p>
              </div>
            </div>
          </div>
        </div>
        <div
          class="fuel_consumption_row_right_section mr-3 vr__bg"
          style="flex: 0 0 65%"
          :style="[
            {
              backgroundImage: `linear-gradient(rgb(12, 4, 31 , 0.92), rgb(12, 4, 31, 0.92)), url(${backgroundUrl})`,
              backgroundPosition: 'center',
              backgroundRepeat: 'no-repeat',
              backgroundSize: 'cover',
            },
          ]"
        >
          <div class="row align-items-center" style="height: 100%">
            <div class="col-md-6">
              <div
                class="transaction_period_text text-center branch__sales__text"
                style="font-size: 22px"
              >
                {{ $t("text.walletTransactions.title") }}
              </div>
            </div>
            <div class="col-md-5 drop_down_input_group">
              <div class="drop_down_section mt-2 mr-2">
                <div class="drop_down_div align-items-center">
                  <vue-ctk-date-time-picker
                    v-model="dateRange"
                    :max-date="maxDate"
                    :range="true"
                    :autoClose="true"
                    :locale="this.$root.$i18n.locale"
                    :custom-shortcuts="customShortcuts"
                    :color="$store.getters.getDatePickerColor"
                    format="DDMMYYYY"
                    formatted="DD/MM/YYYY"
                    :label="$t('text.calendar.dateRange')"
                  />
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="section-2 mt-3">
        <section>
          <div class="dashboard__table__section mt-3">
            <div class="branch__sales__text_header">
              <div class="row">
                <div class="col-md-8">
                  <span style="color: black">
                    <img src="@/assets/img/hand (1).png" class="mr-3" />
                    {{ $t("text.walletTransactions.transBetween") }}
                    {{
                      $d(new Date(startDate), "short", this.$root.$i18n.locale)
                    }}
                    {{ $t("text.and.text") }}
                    {{
                      $d(new Date(endDate), "short", this.$root.$i18n.locale)
                    }}
                  </span>
                </div>
                <div class="col-md-4 text-right"></div>
              </div>

              <WalletHistory :walletHistory="transactions" v-if="!showLoader" />

              <TableLoader :showLoader="showLoader" v-else />
            </div>
          </div>
        </section>
      </div>
    </MasterLayout>
  </div>
</template>

<script>
import MasterLayout from "@/views/Company/MasterLayout.vue";
import backgroundUrl from "@/assets/img/danskebank.jpg";
import configObject from "@/config";
import TableLoader from "@/components/tableLoader/index";
import {
  Page,
  Sort,
  Toolbar,
  Search,
  ExcelExport,
  PdfExport,
} from "@syncfusion/ej2-vue-grids";
import JQuery from "jquery";

import WalletHistory from "@/BreakdownComponent/Company/Remis/RetainerDetails/WalletHistory.vue";

let $ = JQuery;

export default {
  title: "Retainers Wallet Transactions :: Epump Portal",
  name: "AllRetainersWalletTransactions",
  components: {
    MasterLayout,
    TableLoader,
    WalletHistory,
  },
  provide: {
    grid: [Page, Sort, Toolbar, Search, ExcelExport, PdfExport],
  },
  data() {
    return {
      transactions: null,
      totalTran: null,
      usedLang: this.$store.getters.getLanguage,
      formatOptions: { type: "date", format: "dd/MM/yyyy" },
      dateRange: {
        start: this.$moment().subtract(7, "days").format("D-M-YYYY"),
        end: this.$moment().format("D-M-YYYY"),
        shortcut: 7,
      },
      maxDate: this.$moment(new Date()).format("YYYY-MM-DD"),
      customShortcuts: [
        { key: "Today", label: this.$t("text.calendar.today"), value: "day" },
        {
          key: "yesterday",
          label: this.$t("text.calendar.yesterday"),
          value: "-day",
        },
        {
          key: "last7Days",
          label: this.$t("text.calendar.last7Days"),
          value: 7,
        },
        {
          key: "lastWeek",
          label: this.$t("text.calendar.lastWeek"),
          value: "-isoWeek",
        },
        {
          key: "last30Days",
          label: this.$t("text.calendar.last30Days"),
          value: 30,
        },
        {
          key: "lastMonth",
          label: this.$t("text.calendar.lastMonth"),
          value: "-month",
        },
      ],
      backgroundUrl,
      branch: {},
      branchId: null,
      startDate: this.$moment().subtract(7, "days").format("MMMM D, YYYY"),
      endDate: this.$moment().format("MMMM D, YYYY"),
      pageSettings: {
        pageSizes: [10, 20, 50, 100, 200],
        pageCount: 4,
        pageSize: 10,
      },
      toolbar: ["ExcelExport", "PdfExport", "Search"],
      search: { operator: "contains", ignoreCase: true },
      showLoader: false,
      showAll: false,
      company: null,
    };
  },
  watch: {
    company(company) {
      if (company !== null) {
        this.getWalletTransaction();
      }
    },
    dateRange: function (newRange, oldRange) {
      if (newRange.start !== null && newRange.end !== null) {
        this.startDate = this.$moment(newRange.start, "DD-MM-YYYY").format(
          "MMMM D, YYYY"
        );
        this.endDate = this.$moment(newRange.end, "DD-MM-YYYY").format(
          "MMMM D, YYYY"
        );

        this.getWalletTransaction();
      }
    },
  },
  created() {
    this.$eventHub.$on("company", (company) => {
      this.company = company;
    });
    if (this.$route.query.companyId) {
      this.getWalletTransaction();
    }
  },
  mounted() {
    $(".e-input").keyup(function (e) {
      searchFun(e);
    });
    function searchFun(event) {
      var grid = document.getElementsByClassName("e-grid")[0].ej2_instances[0];
      var value = event.target.value;
      grid.search(value);
    }
  },
  methods: {
    excelQueryCellInfo(args) {
      if (args.column.field == "date") {
        args.value = this.$moment(args.value).format("DD/MM/YYYY");
      }
    },
    toolbarClick(args) {
      switch (args.item.text) {
        case "PDF Export":
          this.$refs.dataGrid.pdfExport();
          break;
        case "Excel Export":
          this.$refs.dataGrid.excelExport();
          break;
      }
    },
    refreshGrid() {
      this.$refs.dataGrid.refresh();
    },

    getWalletTransaction() {
      this.showLoader = true;
      const params = {
        startDate: this.startDate,
        endDate: this.endDate,
        PageLimit: 10000,
      };
      this.axios
        .get(
          `${configObject.remisBaseUrl}/D/Retainership/WalletTransactions/${
            this.$route.query.companyId
              ? this.$route.query.companyId
              : this.company.id
          }`,
          {
            params,
            ...configObject.authConfig({ isRemis: true }),
          }
        )
        .then((response) => {
          let index = 0;

          const transactions = response.data.data.data.transactions;
          this.totalTran = response.data.data.pagination.currentPageData;
          transactions.forEach((el) => {
            index++;
            el.index = index;

            el.date = this.$moment(el.date).format("YYYY-MM-DD hh:mma");

            el.assignedTo = el.assignedTo;
            el.locked = "No";
            el.nameOnCard = el.nameOnCard ? el.nameOnCard : "N/A";
            el.activated = el.activated;
          });
          this.showLoader = false;
          this.transactions = transactions;
        })
        .catch((error) => {});
    },
    convertThousand(request) {
      if (!isFinite(request)) {
        return "0.00";
      }
      return request
        .toFixed(2)
        .toString()
        .replace(/\B(?=(\d{3})+(?!\d))/g, ",");
    },
  },
};
</script>
